import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "src/redux";

// Define the shape of your state
export interface PrescriptionState {
    sessionToken?: string;
    locationId?: number;
}

// Initial state
const initialState: PrescriptionState = {
    sessionToken: undefined,
    locationId: undefined,
};

// Create a slice for the value
const prescriptionSlice = createSlice({
    name: "prescriptionSlice",
    initialState,
    reducers: {
        setSessionToken: (state, action: PayloadAction<PrescriptionState>) => {
            state.locationId = action.payload.locationId;
            state.sessionToken = action.payload.sessionToken;
        },
    },
});

// Export the action to set the value
export const { setSessionToken } = prescriptionSlice.actions;

export const currentPrescriptionToken = (state: RootState) => state.prescriptionsSlice.sessionToken;
export const currentPrescriptionLocationId = (state: RootState) =>
    state.prescriptionsSlice.locationId;

// Export the reducer to be added to the store
export default prescriptionSlice;
